import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  userPermission: null,
  userAvatar: null,
  login: () => {},
  logout: () => {},
  att: () => {}
});
